var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicalDocs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "8665853_stethoscope_medical_icon 1",
    clipPath: "url(#clip0_1878_2648)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.9997 4.72489C18.1588 4.72489 16.6663 6.23604 16.6663 8.09988C16.6663 9.48532 17.4918 10.6725 18.6709 11.1927V14.5128C18.6709 16.928 16.5772 18.9003 14.0043 18.9003C11.5043 18.9003 9.45009 17.0398 9.34176 14.714C12.3372 14.0821 14.6663 11.361 14.6663 8.06192V1.54353C14.6663 1.06343 14.3268 0.641557 13.863 0.55212L11.2413 0.0200298C10.6997 -0.0907124 10.1772 0.263283 10.068 0.811889L9.93301 1.47603C9.82363 2.02446 10.1752 2.5556 10.7168 2.66656L11.9955 2.92217V8.04504C11.9955 10.2759 10.2401 12.1216 8.03176 12.1427C5.80759 12.1638 3.99801 10.3472 3.99801 8.09567L3.99509 2.92643L5.27509 2.66858C5.81676 2.56311 6.16717 2.02944 6.05759 1.481L5.92884 0.817057C5.82467 0.26862 5.29759 -0.0861772 4.75592 0.0247759L2.13634 0.547901C1.67259 0.642823 1.33301 1.05837 1.33301 1.54353V8.09946C1.33301 11.3584 3.62926 14.0901 6.67051 14.7145C6.77884 18.5329 10.0247 21.5999 13.9997 21.5999C18.0413 21.5999 21.333 18.4202 21.333 14.5124V11.1922C22.5093 10.6708 23.333 9.48532 23.333 8.10199C23.333 6.2352 21.8413 4.72489 19.9997 4.72489ZM19.9997 9.11239C19.4476 9.11239 18.9997 8.65887 18.9997 8.09988C18.9997 7.5409 19.4455 7.08739 19.9997 7.08739C20.5538 7.08739 20.9997 7.53879 20.9997 8.09988C20.9997 8.66098 20.5538 9.11239 19.9997 9.11239Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1878_2648"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 21.6,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalDocs);
export default __webpack_public_path__ + "static/media/medical-docs.0907909445debd0c3a4ce998c99b29d7.svg";
export { ForwardRef as ReactComponent };